import Wizard from './wizard';
import './wizard.scss';

export default Wizard;
